import { render } from "./TheSideNav.vue?vue&type=template&id=28db1638"
import script from "./TheSideNav.vue?vue&type=script&lang=js"
export * from "./TheSideNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lifet\\workspace\\cna\\cnanonsul-master\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__